export const calculateGridMargin = (): string => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 360) return `${(screenWidth - 4 * 70 - 3 * 16) / 2}px`;
  if (screenWidth <= 767) return `${(screenWidth - 4 * 79 - 3 * 8) / 2}px`;
  if (screenWidth <= 1023) return `${(screenWidth - 12 * 47 - 11 * 16) / 2}px`;
  if (screenWidth <= 1365) return `${(screenWidth - 12 * 68 - 11 * 16) / 2}px`;
  if (screenWidth <= 1439) return `${(screenWidth - 12 * 89 - 11 * 16) / 2}px`;
  if (screenWidth <= 1919) return `${(screenWidth - 12 * 96 - 11 * 16) / 2}px`;
  return `${(screenWidth - 12 * 99 - 11 * 16) / 2}px`;
};

export const calculateMaxWidth = (): string => {
  const screenWidth = window.innerWidth;

  if (screenWidth <= 360) return `${3 * 70 + 2 * 16}px`;
  if (screenWidth <= 767) return `${3 * 79 + 2 * 8}px`;
  if (screenWidth <= 1023) return `${3 * 47 + 2 * 16}px`;
  if (screenWidth <= 1365) return `${3 * 68 + 2 * 16}px`;
  if (screenWidth <= 1439) return `${3 * 89 + 2 * 16}px`;
  if (screenWidth <= 1919) return `${3 * 96 + 2 * 16}px`;
  return `${3 * 99 + 2 * 16}px`;
};
